import React from 'react';
import styled from 'styled-components';

export default function AbountMe() {
  return (
    <Container id="about" className="section">
      <div className="container">
        <Title>About Me</Title>
        <Paragraph className="paragraph">
          I am currently a lecturer in the
          <a target="_blank" rel="noopener noreferrer" href="http://www.it.kmitl.ac.th/"> School of Information Technology </a>
          at the King Mongkut's Institute of Technology Ladkrabang, Bangkok, Thailand. I received my PhD in
          <a target="_blank" rel="noopener noreferrer" href="http://cs.unc.edu/"> Computer Science </a>
          from the University of North Carolina at Chapel Hill, USA,
          in 2016 under the advisorship of
          <a target="_blank" rel="noopener noreferrer" href="http://tamaraberg.com/"> professor Tamara Berg </a>
          and the collaboration with
          <a target="_blank" rel="noopener noreferrer" href="http://acberg.com/"> professor Alex Berg </a>
          . Previously, I received my Master in Computer Science from
          <a target="_blank" rel="noopener noreferrer" href="http://cs.brown.edu/"> the Computer Science Department, Brown University </a>
          in 2011 working with
          <a target="_blank" rel="noopener noreferrer" href="http://www.cc.gatech.edu/~hays/"> professor James Hays </a>
          . I was a member of the Theory of Computation Group during
          my undergrad years at
          <a target="_blank" rel="noopener noreferrer" href="http://www.cs.science.cmu.ac.th/"> the Department of Computer Science, Chiang Mai University </a>
          .</Paragraph>
        <div className="text-right">
          <GoogleScholar target="_blank" rel="noopener noreferrer" href="https://scholar.google.co.th/citations?user=kmb5Re0AAAAJ&hl=en&oi=sra"><GoogleScholarIcon/> Google Scholar</GoogleScholar>
        </div>
      </div>
    </Container>
  )
}


const Container = styled.section`
  background-image: linear-gradient(
    to bottom right,
    #91defe66,
    #99c0f966,
    #bdb6ec66,
    #d7b3e366,
    #efb3d566,
    #f9bccc66
  );
  box-shadow: -37vw -6px 15px 6px #91defe55,
              36vw -6px 15px 6px #bdb6ec55,
              -70vw 6px 15px 6px #d7b3e350,
              28vw 6px 15px 6px #f9bccc55;
  backdrop-filter: blur(10px);
  padding-top: 32px;
  padding-bottom: 32px;
  z-index: 3;
`
const Title = styled.h2`
  font-family: 'Concert One';
`
const Paragraph = styled.p`
  font-size: 1.3em;
  color: var(--text-color);
  text-indent: 60px;
  text-align: justify;

  @media (max-width: 767px) {
    font-size: 1rem;
    text-indent: 0;
    text-align: left;
  }
`
const GoogleScholar = styled.a`
  font-family: "Google Product Sans";
  background-color: transparent;
  color: var(--assent-color);
  text-decoration: none!important;
  padding: 4px 16px 4px 16px;
  height: 48px;
  font-size: 24px;
  border-radius: 24px;
  box-shadow: 6px 6px 18px rgba(var(--assent-color-rgb), .4),
              -6px -6px 14px rgba(255, 255, 255, .7);

  &:HOVER {
    color: var(--assent-color);
  box-shadow: 8px 8px 18px rgba(var(--assent-color-rgb), .5),
              -8px -8px 18px rgba(255, 255, 255, .75);
  }

  display: inline-flex;
  align-items: center;
  min-height: 44px;

  @media (max-width: 575px) {
    width: 100%;
    justify-content: center;
    font-size: 20px;
  }

  & svg{
    width: 32px;
    height: 32px;
    margin-top: -.2em;
  }

`
const GoogleScholarIcon = ()=>(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentcolor" d="M13.823,13.313c0-0.979,2.119-1.267,2.119-3.559c0-1.002-0.069-1.716-0.518-2.223c-0.035-0.035-0.058-0.058-0.092-0.081 c-0.161-0.15-0.346-0.276-0.576-0.392c0-0.334,1.878-0.115,1.878-0.76c-0.323,0-4.112,0-4.112,0s-3.018,0.08-3.905,2.303 c-0.092,0.196-0.15,0.403-0.196,0.622C8.375,9.465,8.34,9.73,8.34,10.007c0,3.571,3.651,3.168,3.651,3.168s0,0.541,0,0.91 c0,0.369,0.484,0.242,0.541,0.991c-0.242,0-5.057-0.138-5.057,3.11c0,3.26,4.25,3.099,4.25,3.099s4.907,0.219,4.907-3.813 C16.634,15.063,13.823,14.28,13.823,13.313z M10.264,10.202C10.091,9.5,10.114,8.82,10.31,8.279 c0.058-0.219,0.15-0.415,0.265-0.576c0.207-0.311,0.484-0.518,0.829-0.61c0.38-0.092,0.772-0.035,1.14,0.173 c0.207,0.104,0.403,0.253,0.576,0.438c0.357,0.357,0.657,0.875,0.818,1.486c0.38,1.451-0.115,2.845-1.14,3.11 C11.784,12.587,10.655,11.642,10.264,10.202z M12.383,20.247c-1.693,0.115-3.156-0.806-3.237-2.062 c-0.081-1.267,1.232-2.373,2.937-2.5c1.693-0.127,3.133,0.806,3.237,2.073C15.39,19.014,14.088,20.132,12.383,20.247z"/><path fill="currentcolor" d="M20,4l-4.571,3.429h-2.286c-0.194-0.206-0.389-0.229-0.594-0.183c-0.366-0.206-0.754-0.263-1.131-0.171 C11.074,7.166,10.8,7.371,10.594,7.68c-0.114,0.16-0.206,0.354-0.263,0.571C9.977,8.423,9,9,9,9H3l8-5H20z"/><line x1="18" x2="18" y1="9" y2="10" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/><line x1="18" x2="18" y1="5" y2="8" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-miterlimit="10"/></svg>
)